"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var TriangleRight = function TriangleRight(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/triangle_right-triangle-right" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "triangle-triangle-right" + unique,
    xlinkHref: "#path-1-triangle-right" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-triangle-right" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.83935955,3.09245624 C6.62114638,2.9232297 6.30706443,2.96294121 6.13783789,3.18115438 C6.06984778,3.26882583 6.03294779,3.37662049 6.03294779,3.48756614 L6.03294779,20.4465852 C6.03294779,20.7227276 6.25680541,20.9465852 6.53294779,20.9465852 C6.64389344,20.9465852 6.7516881,20.9096852 6.83935955,20.8416951 L17.773464,12.3621856 C17.9916771,12.192959 18.0313887,11.8788771 17.8621621,11.6606639 C17.8364367,11.6274917 17.8066362,11.5976912 17.773464,11.5719658 L6.83935955,3.09245624 Z",
    fill: "inherit",
    id: "path-1-triangle-right" + unique
  }))));
};

TriangleRight.propTypes = propTypes;
var _default = TriangleRight;
exports["default"] = _default;